import { render, staticRenderFns } from "./GeneralBusinessCreatePage.vue?vue&type=template&id=5e134218&scoped=true&"
import script from "./GeneralBusinessCreatePage.vue?vue&type=script&lang=js&"
export * from "./GeneralBusinessCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./GeneralBusinessCreatePage.vue?vue&type=style&index=0&id=5e134218&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e134218",
  null
  
)

export default component.exports